import { useLanguage } from '@/contexts/LanguageContext';
import FadeIn from '@/components/FadeIn';

const LOGO_AVIF = 'https://customer-assets.emergentagent.com/job_3ec12bb3-915e-4bbb-87b2-e085aa4a2c01/artifacts/jfotexpw_Logo%20Wee%20V2%20-%202026%20-%20SBG.HQ.avif';
const LOGO_WEBP = 'https://customer-assets.emergentagent.com/job_3ec12bb3-915e-4bbb-87b2-e085aa4a2c01/artifacts/76ox2huh_Logo%20Wee%20V2%20-%202026%20-%20SBG.HQ.webp';

export default function SloganSection() {
  const { t } = useLanguage();

  return (
    <section
      id="slogan"
      data-testid="section-slogan"
      className="min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-24 py-24"
    >
      <div className="md:hidden flex justify-center mb-12">
        <div className="w-72 aspect-square">
          <picture>
            <source srcSet={LOGO_AVIF} type="image/avif" />
            <source srcSet={LOGO_WEBP} type="image/webp" />
            <img
              src={LOGO_WEBP}
              alt={t.slogan.logoAlt}
              fetchPriority="high"
              loading="eager"
              decoding="async"
              width={1200}
              height={1200}
              className="w-full h-full object-contain"
            />
          </picture>
        </div>
      </div>

      <FadeIn>
        <h1
          data-testid="slogan-title"
          className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#35589B] tracking-tight leading-tight"
        >
          {t.slogan.title}
        </h1>
      </FadeIn>

      <FadeIn delay={0.3}>
        <div className="mt-8 w-16 h-[1px] bg-[#35589B]/30" />
      </FadeIn>
    </section>
  );
}
